import { Suspense } from "solid-js";
import { useI18n } from "@/api/i18n";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { InviteFreelancerForm } from "./InviteFreelancerForm";

interface InviteFreelancerModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const InviteFreelancerModal = (props: InviteFreelancerModalProps) => {
  const { t } = useI18n();

  return (
    <Dialog open={props.isOpen} onOpenChange={props.onClose}>
      <DialogContent class="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t("freelancerInvitations.modal.title")}</DialogTitle>
          <DialogDescription>
            {t("freelancerInvitations.modal.description")}
          </DialogDescription>
        </DialogHeader>

        <div class="py-2">
          {/*
            The form mounts on each open and reads the invitation link, cached
            for five minutes. A query hook used for the first time suspends
            the nearest `<Suspense>` on that read, even when the data is
            cached. Without this boundary that is the layout's, which swaps
            the whole page out under the dialog and back: the sidebar button
            that opened it loses focus, and closing cannot give focus back.
          */}
          <Suspense>
            <InviteFreelancerForm
              onSuccess={props.onClose}
              onCancel={props.onClose}
            />
          </Suspense>
        </div>
      </DialogContent>
    </Dialog>
  );
};
